export type GalleryTemplateItem = {
  width: number
}

export type GalleryTemplates = {
  [id: number]: GalleryTemplateItem[]
}

export const templates: GalleryTemplates = {
  1: [
    {
      width: 100,
    },
    {
      width: 100,
    },
  ],
  2: [
    {
      width: 100,
    },
    {
      width: 100,
    },
    {
      width: 100,
    },
  ],
  3: [
    {
      width: 100,
    },
    {
      width: 50,
    },
    {
      width: 50,
    },
    {
      width: 100,
    },
  ],
  4: [
    {
      width: 50,
    },
    {
      width: 50,
    },
    {
      width: 100,
    },
    {
      width: 50,
    },
    {
      width: 50,
    },
  ],
  5: [
    {
      width: 100,
    },
    {
      width: 50,
    },
    {
      width: 50,
    },
    {
      width: 33,
    },
    {
      width: 33,
    },
    {
      width: 33,
    },
  ],
  6: [
    {
      width: 33,
    },
    {
      width: 33,
    },
    {
      width: 33,
    },
    {
      width: 100,
    },
    {
      width: 33,
    },
    {
      width: 33,
    },
    {
      width: 33,
    },
  ],
  7: [
    {
      width: 33,
    },
    {
      width: 33,
    },
    {
      width: 33,
    },
    {
      width: 50,
    },
    {
      width: 50,
    },
    {
      width: 33,
    },
    {
      width: 33,
    },
    {
      width: 33,
    },
  ],
  8: [
    {
      width: 50,
    },
    {
      width: 50,
    },
    {
      width: 50,
    },
    {
      width: 50,
    },
    {
      width: 50,
    },
    {
      width: 50,
    },
  ],
  9: [
    {
      width: 50,
    },
    {
      width: 50,
    },
    {
      width: 50,
    },
    {
      width: 50,
    },
    {
      width: 33,
    },
    {
      width: 33,
    },
    {
      width: 33,
    },
  ],
}

export default {}
